import { useState } from "react";
import { ChevronDown, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Filter multi-pilih berbentuk chip dalam popover (dipakai di Dashboard utama)
export default function ChipMultiFilter({ label, options, value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const toggle = (o) => onChange(value.includes(o) ? value.filter((x) => x !== o) : [...value, o]);
  const ringkas = value.length === 0 ? `Semua ${label}` : value.length <= 2 ? value.join(", ") : `${value.length} ${label.toLowerCase()} dipilih`;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className={`h-10 inline-flex items-center gap-2 rounded-md border px-3 text-sm transition-colors ${value.length ? "border-blue-400 bg-blue-50 text-blue-800" : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50"}`}>
          <span className="max-w-[14rem] truncate">{ringkas}</span>
          {value.length > 0 && <span className="rounded-full bg-blue-600 px-1.5 text-[10px] font-bold text-white" data-testid={`${testId}-count`}>{value.length}</span>}
          <ChevronDown className="h-4 w-4 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-3" data-testid={`${testId}-popover`}>
        <div className="mb-2 flex items-center justify-between text-xs">
          <span className="font-semibold text-slate-600">{label} (bisa pilih &gt;1)</span>
          {value.length > 0 && <button type="button" onClick={() => onChange([])} className="inline-flex items-center gap-1 text-rose-600 hover:underline" data-testid={`${testId}-reset`}><X className="h-3 w-3" /> Reset</button>}
        </div>
        <div className="flex max-h-64 flex-wrap gap-1.5 overflow-auto">
          {options.map((o) => {
            const on = value.includes(o);
            return (
              <button key={o} type="button" onClick={() => toggle(o)} data-testid={`${testId}-opt-${o}`}
                className={`h-7 rounded-full border px-3 text-xs font-semibold transition-colors ${on ? "border-blue-600 bg-blue-600 text-white" : "border-slate-300 bg-white text-slate-500 hover:text-slate-800"}`}>
                {o}
              </button>
            );
          })}
          {options.length === 0 && <span className="text-xs text-slate-400">Tidak ada pilihan.</span>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
